"use strict";

exports.__esModule = true;
exports.timeArray = exports.aggregateTimeDefinitions = void 0;
var _timeAggregationBinMapping = require("../../VIMANAMetrics/timeAggregationBinMapping");
var generateColumnFromTimeGrouping = function generateColumnFromTimeGrouping(_ref) {
  var binName = _ref.binName,
    label = _ref.label,
    type = _ref.type;
  return {
    id: binName,
    name: label,
    label: label,
    groupId: "time_group",
    groupLabel: "Time Period",
    sanitizedFieldName: label,
    type: type,
    enableSorting: false,
    canFilter: false
  };
};
var timeArray = exports.timeArray = _timeAggregationBinMapping.timeGrouping.map(function (t) {
  return t.binName;
});
var aggregateTimeDefinitions = exports.aggregateTimeDefinitions = function aggregateTimeDefinitions() {
  var columns = _timeAggregationBinMapping.timeGrouping.map(generateColumnFromTimeGrouping);
  return {
    columns: columns,
    parseData: {},
    // This is merged with the above definition so override anything configurable to produce a default configuration here
    createDefault: function createDefault() {
      return {
        columns: [],
        enablePagination: true,
        overFetchAll: true,
        defaultPageSize: "auto"
      };
    }
  };
};